import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "inherit",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M1.975 3.306c-.44-.493-.662-.74-.67-.95a.58.58 0 0 1 .212-.472c.161-.134.492-.134 1.154-.134h8.658c.662 0 .993 0 1.154.134.14.116.22.29.212.472-.008.21-.229.457-.67.95l-3.329 3.72a1.2 1.2 0 0 0-.163.203.6.6 0 0 0-.06.159c-.015.062-.015.128-.015.26v3.12c0 .114 0 .17-.018.22a.3.3 0 0 1-.077.114.7.7 0 0 1-.198.099l-1.983.793c-.215.086-.322.129-.408.11a.3.3 0 0 1-.184-.124c-.048-.073-.048-.188-.048-.42V7.649c0-.132 0-.198-.014-.26a.6.6 0 0 0-.06-.159c-.032-.056-.076-.105-.164-.203z"
    }, null, -1)
  ]))]))
}
export default { render: render }